import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ConfiguracoesSyncService } from 'app/services';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {
  @Output() trocarTela: EventEmitter<string> = new EventEmitter<string>();
  public nomeUsuario: string = ''

  constructor(private configuracoesSyncService: ConfiguracoesSyncService) { }
  
  ngOnInit(): void {
    this.nomeUsuario = this.buscarNomeLocalStorage();  
  }
  public irParaConfiguracoesGerais(): void {
    this.configuracoesSyncService.dispararAtualizacao();
    this.trocarTela.emit('configuracoes');
  }

  public buscarNomeLocalStorage(): string {
    return localStorage.getItem('usuarioNome')!.split(' ')[0];
  }
}
